import { useEffect, useRef } from "react";
//#region src/hooks/useStickyStack.ts
/**
* Automatically stacks multiple `position: sticky` elements so they
* don't overlap. Each `[data-sticky]` child inside the ref'd container
* gets its `top` value set to the cumulative height of the sticky
* elements above it. Heights are measured via ResizeObserver so the
* stack adapts to dynamic content.
*
* Usage:
*   const ref = useStickyStack()
*
*   <div ref={ref}>
*     <div>Scrolls away</div>
*     <div data-sticky className="sticky">Sticks at top</div>
*     <div>Scrolls away</div>
*     <div data-sticky className="sticky">Stacks below first</div>
*   </div>
*/
function useStickyStack() {
	const containerRef = useRef(null);
	useEffect(() => {
		const container = containerRef.current;
		if (!container) return;
		const update = () => {
			const stickyItems = container.querySelectorAll("[data-sticky]");
			let top = 0;
			stickyItems.forEach((item) => {
				item.style.top = `${top}px`;
				top += item.getBoundingClientRect().height;
			});
		};
		const stickyItems = container.querySelectorAll("[data-sticky]");
		const observer = new ResizeObserver(update);
		stickyItems.forEach((item) => observer.observe(item));
		return () => observer.disconnect();
	}, []);
	return containerRef;
}
//#endregion
export { useStickyStack };

//# sourceMappingURL=useStickyStack.js.map